<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  fetchInfractionNotices({ status = '', page }) {
    const params = { status, page };
    return axios.get('requerimentos/autos-de-infracao', { params, ...AS.getDefaultHeaders() });
  },
  adminFetchInfractionNotices({ status = '', page }) {
    const params = { status, page };
    return axios.get('admin/requerimentos/defesa', { params, ...AS.getDefaultHeaders() });
  },
  changeInfractionNoticeToPaid(applicationId) {
    return axios.patch(`admin/requerimentos/${applicationId}/requerimento-pago`, null, AS.getDefaultHeaders());
  },
};

</script>